import styled from "styled-components";
import { Icon, darkTheme } from "@evergis/ui";

export const TooltipLabel = styled.div<{ opacity?: number; maxWidth?: number }>`
  display: flex;
  font-size: 0.625rem;
  color: #fff;
  background-color: ${({ opacity = 0.8 }) => `rgba(61, 61, 61, ${opacity})`};
  padding: 0.4em 0.6em;
  border-radius: 0.125rem; /* Todo: 0.125rem is hot fix, why theme doesn't connected? ${({ theme: { borderRadius } }) =>
    borderRadius.smallest} */
  user-select: none;
  box-sizing: border-box;
  white-space: normal;
  max-width: ${({ maxWidth = "unset" }) => `${maxWidth}px`};
`;

export const CloseIcon = styled(Icon)`
  color: #fff;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  height: 0.75rem;
  cursor: pointer;
  width: 0.875rem;

  &:after {
    font-size: 0.56rem;
  }
`;

export const Text = styled.span`
  color: black;
  font-size: 0.75rem;
  font-weight: bold;
  margin-left: -50%;
  margin-top: 9px;
  text-shadow: 2px 2px 2px white;
  white-space: nowrap;
`;

CloseIcon.defaultProps = {
  theme: darkTheme,
};

export const ClosableTooltipLabel = styled(TooltipLabel)`
  font-size: 0.75rem;
  padding: 0.3125rem 0.5rem;
`;
